import { Injectable } from '@angular/core';
import { UrlService } from '@service/url/url.service';
import { RestService } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Injectable({
	providedIn: 'root',
})
export class BrokerHelperService {
	constructor(
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService
	) {}

	processBrokerData(s3Key: string) {
		const url = this.urlService.bulkBroker(s3Key);
		this.restService.POST(url, {}).subscribe(
			(result) => {
				this.utilService.showSnackbar(result.message, SNACKBAR.SUCCESS, SNACKBAR.ACTION);
			},
			(error) => {
				if (error.status == 200) {
					this.utilService.showSnackbar(error.error.text, SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				} else {
					this.utilService.showSnackbar(
						error.data || 'Unable to upload now.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
				}
			}
		);
	}
}
